import api from "./axios";

class ServicePaymentForm {
  async save(paymentForm) {
    const { data } = await api.post(`/payments`, paymentForm);
    return data;
  }

  async update(id, paymentForm) {
    await api.put(`/payments/${id}`, paymentForm);
  }

  async getPaymentFindById(id) {
    const { data } = await api.get(`/payments/${id}`);
    return data;
  }

  async getAllPayment() {
    const { data } = await api.get(`/payments/combobox`);
    return data;
  }

  async deletePayment(id) {
    await api.delete(`/payments/${id}`);
  }
}

export default new ServicePaymentForm()